<template>
  <section class="content">
    <admin-header
      :title="'Transit Miles'"
      :uploader="true"
      v-on:open-filter="openFilter"
      v-on:create-entity-request="goToNewEntityScreen"
      v-on:entity-quick-search="search"
      v-on:csv-upload="multiSave"
      :disableQuickSearch="true"
    ></admin-header>
    <div id="admin-content">
      <router-view></router-view>
    </div>
  </section>
</template>
<script>
  import AdminHeader from '../AdminHeader'
  import AdminScreenMixin from '../../mixins/AdminScreenMixin'
  export default {
    components: {AdminHeader},
    mixins: [AdminScreenMixin],
    name: 'AdminTransitMile',
    data () {
      return {
        newEntityScreen: 'Admin - Transit Miles',
        searchEntityScreen: 'Admin - Transit Mile search',
        filterEventName: 'admin-transit-mile-filter',
        filterName: 'TransitMileFilter',
        entityName: 'transit-miles',
        transformFilterRequest: true
      }
    }
  }
</script>
<style>
</style>



// WEBPACK FOOTER //
// AdminTransitMile.vue?0e5b45c7